export default __webpack_public_path__ + "static/media/BatteryMaintenance1.9cd01d3d.png";